//#region src/types/HostActionFigure.ts
var e = /* @__PURE__ */ function(e) {
	return e.YouEarn = "YOU_EARN", e.Outstanding = "OUTSTANDING", e.Delta = "DELTA", e.Total = "TOTAL", e.Available = "AVAILABLE", e;
}({});
//#endregion
export { e as HostActionFigureCaption };
